import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import type { AcknowledgementPayloadDTO, AcknowledgementResponseDTO } from "@/core/types";
import { getPatientProfile } from "@/redux/actions/auth";

import { appendAcknowledgement } from "../queryFunctions/appendAcknowledgement";

type UseAppendAcknowledgementOptions = UseMutationOptions<
  AcknowledgementResponseDTO,
  unknown,
  AcknowledgementPayloadDTO
>;

export function useAppendAcknowledgement(options?: UseAppendAcknowledgementOptions) {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: appendAcknowledgement,
    ...options,
    onSuccess: (...args) => {
      /** Refetch profile to redraw the updated view
       * This is a temporary solution until we move profile data to tanstack query
       */
      dispatch(getPatientProfile(true));
      // Execute caller-supplied callback
      options?.onSuccess?.(...args);
    },
  });
}
